module.exports = __webpack_public_path__ + "static/media/moodswings-light.0a3baaee.png";